import React, { useMemo, useState } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';
import cx from 'classnames';
import URI from 'urijs';
import { withRouter } from 'react-router';

import { BlogContext, BlogList } from '../../components/blog/list';

// modules
import BS from '../../theme/Bootstrap';

export function RealEstateNews(props) {
  const path = props.match.path;
  const query = useMemo(
    () => URI(props.location.search).search(true),
    [props.location.search]
  );
  const currentPage = isNaN(query.page) ? 1 : parseInt(query.page, 10);

  const [results, setResults] = useState();
  const blogContext = useMemo(() => {
    return {
      filters: query,
      setResults
    };
  }, [query]);

  return (
    <Container fluid>
      <Container>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/designations">
              <BreadcrumbItem active>Real Estate News</BreadcrumbItem>
            </LinkContainer>
          </Breadcrumb>
        </Row>
      </Container>
      <Container className={cx(BS.pt3)}>
        <p>
          Naples real estate market statistics are compiled on the 10th of each month.
          Calculations are based on Naples Real Estate property listings that exist within
          the Southwest Florida MLS. Only properties in Collier County, excluding Marco
          Island, are included.
        </p>

        <BlogContext.Provider value={blogContext}>
          <BlogList
            {...query}
            excerptOnly
            limit={10}
            page={currentPage}
            tags={'market-stats'}
          />
        </BlogContext.Provider>

        <div className={cx(BS.inputGroupGutter, BS.mb3, BS.mt3)}>
          <Button
            tag={Link}
            color="dark-blue"
            disabled={currentPage === 1}
            to={URI(path)
              .search({
                ...query,
                page: currentPage - 1
              })
              .toString()}
          >
            Previous Page
          </Button>
          <Button
            tag={Link}
            color="dark-blue"
            disabled={!results || !results.length}
            to={URI(path)
              .search({
                ...query,
                page: currentPage + 1
              })
              .toString()}
          >
            Next Page
          </Button>
        </div>
      </Container>
    </Container>
  );
}

export default connect()(withRouter(RealEstateNews));



// WEBPACK FOOTER //
// ./src/containers/RealEstateNews/RealEstateNews.js